// DigitalSetu — global brand constants shared across public site + admin app.
export const BRAND = {
  name: "DigitalSetu",
  legalName: "Priyanka Enterprises",
  tagline: "Connecting Citizens to Government Services",
  sub: "by Priyanka Enterprises",
  authorization: "DigitalSetu Authorized Service Center",
  domain: "digitalsetu.in",

  // ----- Contact -----
  whatsapp: "+91 81694 82911",
  whatsappDigits: "918169482911",          // wa.me/<digits>
  phone: "+91 81694 82911",
  email: "hello@digitalsetu.in",

  // ----- Address -----
  address: {
    line1: "Shop No. 4, Ground Floor, Yakub Manzil",
    line2: "Road No. 27, Shanti Nagar",
    line3: "Wagle Estate",
    city:  "Thane",
    pincode: "400604",
    state: "Maharashtra",
    country: "India",
  },
  mapUrl: "https://share.google/kM9qYjkUHj1RbC8uj",
  hours: "Mon–Sat · 9:00 AM – 8:00 PM",

  socials: {
    facebook:  "",
    instagram: "",
    youtube:   "",
    twitter:   "",
  },
};

// Colour palette (Royal Blue + Green + Orange accent + Off-white)
export const COLORS = {
  primary: "#1e3a8a",
  primaryDark: "#1e2f6b",
  primaryLight: "#2e5fdf",
  accent: "#ea580c",
  success: "#059669",
  bg: "#f8fafc",
  bgAlt: "#eef2ff",
};

// Helper links
export const waLink = (msg = "") =>
  `https://wa.me/${BRAND.whatsappDigits}${msg ? `?text=${encodeURIComponent(msg)}` : ""}`;

export const fullAddress = () =>
  `${BRAND.address.line1}, ${BRAND.address.line2}, ${BRAND.address.line3}, ${BRAND.address.city} – ${BRAND.address.pincode}`;

// Simple weekday open-hours check (Mon–Sat, 9am–8pm IST)
export const isOpenNow = () => {
  const d = new Date();
  const day = d.getDay(); // 0 Sun, 6 Sat
  const hour = d.getHours();
  const isBusinessDay = day >= 1 && day <= 6;
  const isOpenHour = hour >= 9 && hour < 20;
  return isBusinessDay && isOpenHour;
};

export default BRAND;
